import { invoiceFragment, reviewOrderFragment, invoiceNoteFragment, orderDetailsFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const createPerOrderInvoicesTemplate = gql`
    mutation createPerOrderInvoices($invoices: [PerOrderInvoice!]!) {
        createPerOrderInvoices(invoices: $invoices) {
            ...reviewOrderFields
        }
    }
    ${reviewOrderFragment}
`;

export const toggleOrderReadyForInvoiceTemplate = gql`
    mutation toggleOrderReadyForInvoice($orderId: String!, $invoiceAction: String) {
        toggleOrderReadyForInvoice(orderId: $orderId, invoiceAction: $invoiceAction) {
            ...reviewOrderFields
        }
    }
    ${reviewOrderFragment}
`;

export const createCollectiveInvoicesTemplate = gql`
    mutation createCollectiveInvoices($invoices: [CreateCollectiveInvoice!]!, $shouldSendEmails: Boolean) {
        createCollectiveInvoices(invoices: $invoices, shouldSendEmails: $shouldSendEmails) {
            _id
            status
            failedInvoices {
                invoiceId
                invoiceNumber
                clinicName
                errorMessage
                provider
            }
        }
    }
`;

export const createOrderInvoiceTemplate = gql`
    mutation createOrderInvoice($orderId: String!, $invoiceNumber: String!, $shouldSendEmails: Boolean) {
        createOrderInvoice(orderId: $orderId, invoiceNumber: $invoiceNumber, shouldSendEmails: $shouldSendEmails) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;

export const flagInvoiceAsPaidTemplate = gql`
    mutation flagInvoiceAsPaid($invoiceId: MongoDbObjectId!, $paidOn: Date!, $sentDate: Date!) {
        flagInvoiceAsPaid(invoiceId: $invoiceId, paidOn: $paidOn, sentDate: $sentDate) {
            _id
            paidOn
            paymentStatus
            sentDate
            status
        }
    }
`;

export const flagInvoiceAsUnpaidTemplate = gql`
    mutation flagInvoiceAsUnpaid($invoiceId: MongoDbObjectId!) {
        flagInvoiceAsUnpaid(invoiceId: $invoiceId) {
            _id
            paidOn
            paymentStatus
        }
    }
`;

export const setInvoiceSentDateTemplate = gql`
    mutation setInvoiceSentDate($invoiceId: MongoDbObjectId!, $sentDate: Date!) {
        setInvoiceSentDate(invoiceId: $invoiceId, sentDate: $sentDate) {
            _id
            sentDate
            status
        }
    }
`;

export const emailPdfTemplate = gql`
    mutation emailPdf($invoiceId: MongoDbObjectId!, $emailSettings: EmailSettingsInput!) {
        emailPdf(invoiceId: $invoiceId, emailSettings: $emailSettings) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;

export const createFullCreditInvoiceTemplate = gql`
    mutation createFullCreditInvoice($fullCreditInvoice: FullCreditInvoiceArgs!) {
        createFullCreditInvoice(fullCreditInvoice: $fullCreditInvoice) {
            ...invoiceFields
            debitInvoice {
                _id
                invoiceNumber
            }
            creditInvoices {
                _id
                invoiceNumber
                total {
                    total
                    currency
                    vat
                    totalIncVat
                }
            }
        }
    }
    ${invoiceFragment}
`;

export const createInvoiceNoteTemplate = gql`
    mutation createInvoiceNote($invoiceNote: InvoiceNoteInput!) {
        createInvoiceNote(invoiceNote: $invoiceNote) {
            ...invoiceNoteFields
        }
    }
    ${invoiceNoteFragment}
`;

export const updateInvoiceNoteTemplate = gql`
    mutation updateInvoiceNote($invoiceNote: InvoiceNoteInput!, $invoiceNoteId: MongoDbObjectId!) {
        updateInvoiceNote(invoiceNote: $invoiceNote, invoiceNoteId: $invoiceNoteId) {
            ...invoiceNoteFields
        }
    }
    ${invoiceNoteFragment}
`;

export const deleteInvoiceNoteTemplate = gql`
    mutation deleteInvoiceNote($invoiceNoteId: MongoDbObjectId!) {
        deleteInvoiceNote(invoiceNoteId: $invoiceNoteId)
    }
`;

export const toggleOrderDoNotInvoiceTemplate = gql`
    mutation toggleOrderDoNotInvoice($orderId: MongoDbObjectId!, $isDoNotInvoice: Boolean!) {
        toggleOrderDoNotInvoice(orderId: $orderId, isDoNotInvoice: $isDoNotInvoice) {
            ...orderDetailsFields
        }
    }
    ${orderDetailsFragment}
`;

export const cancelScheduleInvoiceTemplate = gql`
    mutation cancelScheduleInvoice($invoiceId: MongoDbObjectId!, $orderId: MongoDbObjectId!) {
        cancelScheduleInvoice(invoiceId: $invoiceId, orderId: $orderId)
    }
`;

export const retryCreateOrderInvoiceTemplate = gql`
    mutation retryCreateOrderInvoice($invoiceId: MongoDbObjectId!) {
        retryCreateOrderInvoice(invoiceId: $invoiceId) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;

export const retryCreateCollectiveInvoiceTemplate = gql`
    mutation retryCreateCollectiveInvoice($invoiceId: MongoDbObjectId!) {
        retryCreateCollectiveInvoice(invoiceId: $invoiceId) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;
